import request from '@/utils/request';
//黑名单列表
export function getBlackList(values) {
  return request('/blacklist/queryPage', {
    method: 'POST',
    data: values,
  });
}
// 删除黑名单
export function deleteBlack(values) {
  return request('/blacklist/delete', {
    method: 'POST',
    data: values,
  });
}
